import React, {Component} from 'react'
import { TableHeaderColumn } from "react-bootstrap-table";
import Grid from '../../../Utils/Grid/index';
import { standardActions } from "../../../Utils/Grid/StandardActions";
import {RenderMoneda, RenderDateTime} from "../../../Utils/renderField/renderTableField";
import {Monedas} from "../../../../../utility/constants";


export default class ProductosGrid extends Component{
    getsimbolo =(valor)=>{
        let simbolo =''
        Monedas.forEach((item,index)=>{
            if (item.value === valor){
                simbolo = item.simbolo
            }
        })
        return simbolo + '. '
    }
    render(){
        const { detalle_orden,moneda, loader, listar: onPageChange, onSortChange, eliminar, permiso } = this.props
        console.log("permisos", this.props.permisos)
        return(
            <div className="margin-tabgrid px-3">
                <Grid hover striped data={{count:10,results:detalle_orden}} loading={loader} onPageChange={onPageChange} onSortChange={onSortChange} pagination={false}>
                    <TableHeaderColumn
                        dataField="producto"
                        dataSort
                        dataFormat = {
                            (cell)=>(cell.nombre)
                        }
                        isKey
                    >
                        PRODUCTO
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="precio_unitario"
                        dataSort
                        dataFormat ={
                            (cell, row)=>(
                                <RenderMoneda monto={cell? cell: 0} simbolo={this.getsimbolo(moneda)} />
                            )
                        }
                    >
                        COSTO DEL PRODUCTO
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="cantidad"
                        dataSort
                    >
                        CANTIDAD
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="cantidad"
                        dataSort
                        dataFormat={
                            (cell,row)=>( 
                                <RenderMoneda monto={cell? row.cantidad * row.precio_unitario: 0} simbolo={this.getsimbolo(moneda)} />
                                
                            )
                        }
                    >
                        SUBTOTAL
                    </TableHeaderColumn>
                </Grid>
                {
                    permiso && (
                    <div className="col-md-12 m-0 p-0 inline-headers text-md-right">
                        <span className="t-primary h4 mr-3" htmlFor="descripcion">TOTAL: <RenderMoneda monto={this.props.total_detalle} simbolo={this.getsimbolo(moneda)} /> </span>
                        
                    </div> 
                    )
                }                
            </div>
        )
    }

}